var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66699V30.0003C5 30.8844 5.35119 31.7322 5.97631 32.3573C6.60143 32.9825 7.44928 33.3337 8.33333 33.3337H31.6667C32.5507 33.3337 33.3986 32.9825 34.0237 32.3573C34.6488 31.7322 35 30.8844 35 30.0003V13.3337H28.3333",
    stroke: "black",
    strokeWidth: 3.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66699H28.3333V30.0003C28.3333 30.8844 28.6845 31.7322 29.3096 32.3573C29.9348 32.9825 30.7826 33.3337 31.6667 33.3337M21.6667 14.3337H11.6667M21.6667 21.0003H15",
    stroke: "black",
    strokeWidth: 3.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsNotFoundIcon);
export default __webpack_public_path__ + "static/media/NewsNotFoundIcon.c7ae53c14eb84548a2aaad441fd28547.svg";
export { ForwardRef as ReactComponent };